export default {
	home: {
		title: '首页'
	}
}
